import { render, staticRenderFns } from "./AnimateField.vue?vue&type=template&id=4c4ef38e&scoped=true&"
import script from "./AnimateField.vue?vue&type=script&lang=ts&"
export * from "./AnimateField.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c4ef38e",
  null
  
)

export default component.exports